import type { Task, UpdateTechnicianCommentDto } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";

/** The technician's comment on a task, from the worker detail page. Task twin of the appointment hook. */
export function useUpdateTaskTechnicianComment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, dto }: { id: number; dto: UpdateTechnicianCommentDto }) =>
      taskApi.updateTechnicianComment(id, dto).then((r) => r.data),
    onSuccess: (task) => {
      queryClient.setQueryData(taskKeys.detail(task.id), (prev: Task | undefined) =>
        prev ? { ...prev, technicianComment: task.technicianComment } : prev,
      );
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: taskKeys.all });
      // The board reads `GET /schedule` and marks blocks that carry a comment — see useCompleteTask.
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
    },
  });
}
